import React from 'react';
import styled from 'styled-components';
//import Button from './Button';
import { Tap } from '../dooh-react-utils';
import { preloader } from '../img';

function format(t) {
  let hs = Math.round((t % 1000) / 10);
  let s = Math.floor((t / 1000) % 60);
  let m = Math.floor(t / (60 * 1000));
  return `${m}:${s < 10 ? '0' : ''}${s}:${hs < 10 ? '0' : ''}${hs}`;
}

export default function Result(props) {
  return (
    <Wrap>
      <div className="time">{format(props.time)}</div>
      <Tap onTap={props.gotoNextScreen}>
        Prijavi
        <br />
        igru
      </Tap>
    </Wrap>
  );
}

const Wrap = styled.div`
  background: url('${() =>
    preloader.get(require('../img/result.png'))}') no-repeat 0 0;
  position: absolute;
  top: 0;

  .time {
    width: 100%;
    text-align: center;
    color: #57463C;
    font-size: 200px;
    position: absolute;
    top: 880px;
  }

  img {
    position: absolute;
    bottom: 150px;
    right: 0px;

    animation-name: bottle-animation;
    animation-duration: 0.8s;
    animation-delay: 0.2s;
    animation-fill-mode: forwards;
    opacity: 0;
    transform: scale(0.9);
  }

  @keyframes bottle-animation {
    0% {
      opacity: 0;
      transform: scale(0.9);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .Tap {
    position: absolute;
    padding-top: 20px;
    border-top: 5px solid #57463C;
    text-align: center;
    color: #57463C;
    font-size: 70px;
    position: absolute;
    top: 1180px;
    left: 400px;
    text-transform: uppercase;

    animation-name: btn-animation;
    animation-duration: 0.5s;
    animation-delay: 0.1s;
    animation-fill-mode: forwards;
    opacity: 0;
  }

  @keyframes btn-animation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }


`;
